import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Loader } from 'src/components';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { usePolicyDetails, usePolicyTabCounts } from 'src/hooks/environmentWdacPolicy';
import { policyDetailsTabs } from './constants';

const PolicyDetailsPage = () => {
  const { policyId } = useParams();

  const { data: policy, isLoading } = usePolicyDetails({ envPolicyId: policyId });

  const { data: tabCounts, isLoading: countsIsLoading } = usePolicyTabCounts({
    envPolicyId: policyId,
  });

  if (isLoading) {
    return <Loader />;
  }

  const latestVersion = policy?.latestVersion?.policyVersion;

  return (
    <TabsPageLayout
      hasBackButton
      // Named after its latest version, since a policy's name can change between versions.
      title={
        <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
          {policy?.policyName || ''}
          {latestVersion && (
            <Box component="span" sx={{ color: '#cdf3ceff', fontSize: '0.9em', fontWeight: 400 }}>
              ({latestVersion})
            </Box>
          )}
        </Box>
      }
      tabs={policyDetailsTabs(policyId, tabCounts, countsIsLoading)}
      wrapperProps={{
        sx: {
          maxWidth: '100%',
        },
      }}
      titleProps={{
        fontSize: '1.4rem',
      }}
    />
  );
};

export default PolicyDetailsPage;
